/*
 * Copyright (c) 2018. keni <$email>
 *
 * This file est-mdb_buttons.js is part of event_pass_client.dev.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 * est-mdb_buttons.js can not be copied and/or distributed
 * without the express permission of keni
 */

'use strict';

(function ($) {
	$(document).ready(function () {

		// jQuery reverse
		$.fn.reverse = [].reverse;

		// // Hover behaviour: make sure this doesn't work on .click-to-toggle FABs!
		// $(document).on('mouseenter.fixedActionBtn', '.fixed-action-btn:not(.click-to-toggle)', function () {
		//    console.log('mouseenter');
		//
		//    let $this = $(this);
		//   openFABMenu($this);
		// });
		// $(document).on('mouseleave.fixedActionBtn', '.fixed-action-btn:not(.click-to-toggle)', function () {
		//    console.log('mouseleave');
		//
		//    let $this = $(this);
		//   closeFABMenu($this);
		// });
		//
		// // Toggle-on-click behaviour. on the main trigger button
		// $(document).on('click.fixedActionBtn', '.fixed-action-btn.click-to-toggle > a', function () {
		//   console.log('click');
		//   let $this = $(this),
		//      $menu = $this.parent();
		//
		//   if ($menu.hasClass('active')) {
		//     closeFABMenu($menu);
		//   } else {
		//     openFABMenu($menu);
		//   }
		// });
	});

	$.fn.extend({
		openFAB: function openFAB() {
			console.log('openFAB', this);
			openFABMenu($(this));
		},
		closeFAB: function closeFAB() {
			console.log('closeFAB', this);

			closeFABMenu($(this));
		}
	});

	let openFABMenu = function openFABMenu(btn) {
		console.log('openFABMenu');

		let $this = btn;
		if ($this.hasClass('active') === false) {

			// Get direction option
			let horizontal = $this.hasClass('horizontal');
			let offsetY = void 0,
				offsetX = void 0;

			if (horizontal === true) {
				offsetX = 40;
			}
			else {
				offsetY = 40;
			}

			$this.addClass('active');
			$this.find('ul .btn-floating').velocity({
				scaleY: '.4',
				scaleX: '.4',
				translateY: offsetY + 'px',
				translateX: offsetX + 'px'
			}, {
				duration: 0
			});

			let time = 0;
			$this.find('ul .btn-floating').reverse().each(function () {
				$(this).velocity({
					opacity: '1',
					scaleX: '1',
					scaleY: '1',
					translateY: '0',
					translateX: '0'
				}, {
					duration: 80,
					delay: time
				});
				time += 40;
			});
		}
	};

	let closeFABMenu = function closeFABMenu(btn) {
		console.log('closeFABMenu');
		let $this = btn;
		// Get direction option
		let horizontal = $this.hasClass('horizontal');
		let offsetY = void 0,
			offsetX = void 0;

		if (horizontal === true) {
			offsetX = 40;
		}
		else {
			offsetY = 40;
		}

		$this.removeClass('active');
		let time = 0;
		$this.find('ul .btn-floating').velocity('stop', true);
		$this.find('ul .btn-floating').velocity({
			opacity: '0',
			scaleX: '.4',
			scaleY: '.4',
			translateY: offsetY + 'px',
			translateX: offsetX + 'px'
		}, {
			duration: 80
		});
	};

	$('.fixed-action-btn').on({
		click: function click(e) {
			e.preventDefault();
			toggleFABMenu($('.fixed-action-btn'));
			return false;
		}
	});
	$('.fixed-action-btn').each(function () {
		closeFABMenu($(this));

	});

	function toggleFABMenu(btn) {

		let $this = btn;
		if ($this.hasClass('active') === false) {
			$this.addClass('active');
			$this.find('ul .btn-floating').velocity({
				scaleY: '.4',
				scaleX: '.4',
				translateY: '40px'
			}, {
				duration: 0
			});

			let time = 0;
			$this.find('ul .btn-floating').reverse().each(function () {
				$(this).velocity({
					opacity: '1',
					scaleX: '1',
					scaleY: '1',
					translateY: '0'
				}, {
					duration: 80,
					delay: time
				});
				time += 40;
			});
		}
		else {
			$this.removeClass('active');
			let _time = 0;
			$this.find('ul .btn-floating').velocity('stop', true);
			$this.find('ul .btn-floating').velocity({
				opacity: '0',
				scaleX: '.4',
				scaleY: '.4',
				translateY: '40px'
			}, {
				duration: 80
			});
		}
	}
})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/components/modified/est-mdb_buttons.js